import { useCallback, useState } from "react";
import { SquiggleTypes } from "../types/types";
import SideList from "./SideList";

import './SideMenu.css';
import { useAdventureDataContext } from "../context/AdventureDataContext";
import { faBook, faCompass, faCube, faLocationDot, faUserGroup } from "@fortawesome/free-solid-svg-icons";

// This is when the item area would otherwise become a single column
const isDrawer = () => typeof window !== "undefined" && window.innerWidth < 914;

function SideMenu({
    addPrepare,
    addQuest,
    addPersonOrOrg,
    addPlace,
    addMiscItem,
    addLogEntry,
    openItem
    }: {
  addPrepare: () => void;
  addQuest: () => void;
  addPersonOrOrg: () => void;
  addPlace: () => void;
  addMiscItem: () => void;
  addLogEntry: () => void;
    openItem: (itemId: string) => void;
}) {
  const [focusType, setFocusType] = useState<SquiggleTypes|null>(null);
  const [hidden, setHidden] = useState<boolean>(isDrawer());
  const { quests, peopleAndOrgs, places, misc, logEntries } = useAdventureDataContext();

  const allSelected = !hidden && focusType === null;
  const questsSelected = !hidden && focusType === 'quest';
  const peopleAndOrgsSelected = !hidden && focusType === 'personororg';
  const placesSelected = !hidden && focusType === 'place';
  const miscSelected = !hidden && focusType === 'miscitem';
  const logEntriesSelected = !hidden && focusType === 'logentry';

  const clickTab = useCallback((selectedFocusType : SquiggleTypes|null) => {
    if (selectedFocusType === focusType) {
      setHidden(!hidden);
    } else {
      setFocusType(selectedFocusType);
      setHidden(false);
    }
  }, [focusType, setFocusType, hidden, setHidden]);

  const itemSelected = useCallback((itemId: string) => {
    if (isDrawer()) {
      setHidden(true);
    }
    openItem(itemId);
  }, [openItem]);

  return (
    <>
      <div id="sidemenubackdrop" style={{width: hidden ? "27px" : undefined}} onClick={() => setHidden(true)} />
      <div id="sidemenu">
        <div className="tabs">
          <div className={"tab all" + (allSelected ? " selected" : "")} onClick={() => clickTab(null)}>All</div>
          <div className={"tab quest" + (questsSelected ? " selected" : "")} onClick={() => clickTab("quest")}>Quests</div>
          <div className={"tab personororg" + (peopleAndOrgsSelected ? " selected" : "")} onClick={() => clickTab("personororg")}>People & Groups</div>
          <div className={"tab place" + (placesSelected ? " selected" : "")} onClick={() => clickTab("place")}>Places</div>
          <div className={"tab miscitem" + (miscSelected ? " selected" : "")} onClick={() => clickTab("miscitem")}>Miscellaneous</div>
          <div className={"tab logentry" + (logEntriesSelected ? " selected" : "")} onClick={() => clickTab("logentry")}>Log</div>
        </div>
        {
          !hidden &&
          <div id="sidelists">
            { (allSelected || questsSelected) && <SideList heading="Quests" icon={faCompass} extraClass="quests" addPrepare={addPrepare} addClick={addQuest} selectClick={itemSelected} items={quests} showProperty="name" focus={() => clickTab((!focusType && "quest") || null)} /> }
            { (allSelected || peopleAndOrgsSelected) && <SideList heading="People & Groups" icon={faUserGroup} extraClass="peopleandorgs" addPrepare={addPrepare} addClick={addPersonOrOrg} selectClick={itemSelected} items={peopleAndOrgs} showProperty="name" focus={() => clickTab((!focusType && "personororg") || null)} /> }
            { (allSelected || placesSelected) && <SideList heading="Places" icon={faLocationDot} extraClass="places" addPrepare={addPrepare} addClick={addPlace} selectClick={itemSelected} items={places} showProperty="name" focus={() => clickTab((!focusType && "place") || null)} /> }
            { (allSelected || miscSelected) && <SideList heading="Miscellaneous" icon={faCube} extraClass="misc" addPrepare={addPrepare} addClick={addMiscItem} selectClick={itemSelected} items={misc} showProperty="name" focus={() => clickTab((!focusType && "miscitem") || null)} /> }
            { (allSelected || logEntriesSelected) && <SideList heading="Log" icon={faBook} extraClass="logentries" addPrepare={addPrepare} addClick={addLogEntry} selectClick={itemSelected} items={logEntries} showProperty="name" focus={() => clickTab((!focusType && "logentry") || null)} /> }
          </div>
        }
      </div>
    </>
  );
}

export default SideMenu;